<template>
  <div class="agency_recommd container">
    <div class="container-head">
      <div class="head-left">
        您可能还需要
      </div>
    </div>
    <div class="maybe">
      <div class="row">
        <div
          class="col-lg-2 col-md-4  col-sm-4 col-xs-4"
          v-for="item in icon_list"
          :key="item.id"
          v-if="item.name != is_include"
        >
          <div class="maybe_item" @click="pageLink(item.id)">
            <div class="maybe_icon">
              <img :src="item.icon_image" />
            </div>
            <div class="maybe_text">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["is_include"],
  data() {
    return {
      icon_list: [
        {
          id: 1,
          icon_image: "../../static/otherpage/icon_2_7.png",
          name: "公司注册"
        },
        {
          id: 2,
          icon_image: "../../static/otherpage/icon_2_1.png",
          name: "代理记账"
        },
        {
          id: 3,
          icon_image: "../../static/otherpage/icon_2_2.png",
          name: "商标注册"
        },
        {
          id: 4,
          icon_image: "../../static/otherpage/icon_2_3.png",
          name: "知识产权"
        },
        {
          id: 5,
          icon_image: "../../static/otherpage/icon_2_4.png",
          name: "许可证办理"
        },
        {
          id: 6,
          icon_image: "../../static/otherpage/icon_2_5.png",
          name: "公司服务"
        },
        {
          id: 7,
          icon_image: "../../static/otherpage/icon_2_6.png",
          name: "医疗器械许可"
        }
      ]
    };
  },
  methods: {
    pageLink(id) {
      switch (id) {
        case 1:
          this.$router.push({
            path: "companyregister"
          });

          break;
        case 2:
          this.$router.push({
            path: "agency"
          });
          break;
        case 3:
          this.$router.push({
            path: "logoregister"
          });
          break;
        case 4:
          this.$router.push({
            path: "knowledge"
          });
          break;
        case 5:
          this.$router.push({
            path: "license"
          });
          break;
        case 6:
          this.$router.push({
            path: "services"
          });
          break;
        case 7:
          this.$router.push({
            path: "medical"
          });
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.agency_recommd {
  flex-direction: column;
  @media (max-width: 991px) {
    padding: 0;
  }
}
[class*="col-"] {
  padding: 0 0.05rem;
}
.row {
  margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/maybe.vue